import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconPasswordShow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.9997 15.5456C7.07879 15.5456 3.7545 12.7127 2.0498 11.0441C1.38031 10.3887 1.40337 9.33974 2.10227 8.71588C3.82203 7.18078 7.10847 4.63647 9.9997 4.63647C12.891 4.63647 16.1773 7.18078 17.8972 8.71588C18.5961 9.33974 18.6191 10.3887 17.9496 11.0441C16.2449 12.7127 12.9206 15.5456 9.9997 15.5456Z",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99947 13.0456C11.6312 13.0456 12.954 11.7228 12.954 10.091C12.954 8.45927 11.6312 7.13647 9.99947 7.13647C8.36772 7.13647 7.04492 8.45927 7.04492 10.091C7.04492 11.7228 8.36772 13.0456 9.99947 13.0456Z",
  stroke: "#000",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 16C6.88016 16 3.34016 12.88 1.52016 11.05C1.35093 10.8807 1.21779 10.6789 1.12881 10.4566C1.03982 10.2344 0.99683 9.99647 1.00244 9.75716C1.00805 9.51786 1.06214 9.28218 1.16144 9.06437C1.26074 8.84657 1.40318 8.65118 1.58016 8.49C3.41016 6.8 6.92016 4 10.0002 4C13.0802 4 16.5902 6.8 18.4202 8.49C18.5971 8.65118 18.7396 8.84657 18.8389 9.06437C18.9382 9.28218 18.9923 9.51786 18.9979 9.75716C19.0035 9.99647 18.9605 10.2344 18.8715 10.4566C18.7825 10.6789 18.6494 10.8807 18.4802 11.05C16.6602 12.88 13.1202 16 10.0002 16Z",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99961 13.1501C11.7393 13.1501 13.1496 11.7398 13.1496 10.0001C13.1496 8.2604 11.7393 6.8501 9.99961 6.8501C8.25991 6.8501 6.84961 8.2604 6.84961 10.0001C6.84961 11.7398 8.25991 13.1501 9.99961 13.1501Z",
  stroke: "#000",
  strokeWidth: 1.5
}));
export { IconPasswordShow };